import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@src/reducers/store";
import { getCurrentFirmwareVersionUseCase } from "@src/cloud-connect/ota-update/use-cases/get-firmware-current-version";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { updateConnectionView } from "@src/reducers/your-reducer";
import {
  FIRMWARE,
  ProcessTypes,
} from "../../../cloud-connect/ota-update/constants";
import { getInstallationProcessListUseCase } from "@src/cloud-connect/ota-update/use-cases/get-installation-process-list-use-case";

export const useOtaUpdateView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean | null>(null);

  const otaActiveView = useSelector(
    (state: RootState) => state.yourSlice.otaActiveView,
  );

  const connectionView = useSelector(
    (state: RootState) => state.yourSlice?.connectionView,
  );

  const fetchCurrentFirmwareVersion = async (signal?: AbortSignal) => {
    setIsLoading(true);

    try {
      const result = await getInstallationProcessListUseCase(signal);
      console.log("Installation Process List Result:", result);
      if (signal?.aborted) return;

      if (result.success && result.data) {
        const completedInstallationProcess = result.data.data.find(
          (process) =>
            process.status === "completed" &&
            process.type === ProcessTypes.FIRMWARE_PUSH,
        );
        dispatch(
          updateConnectionView({
            authentication: connectionView?.authentication,
            source: {
              ...connectionView.source,
              current_firmware_version:
                completedInstallationProcess?.firmware?.version || "",
            },
            state: connectionView?.state,
          }),
        );
      } else {
        errorSnackbar(result.error, 5000);
      }
    } catch (error) {
      errorSnackbar("Failed to fetch firmware version", 5000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (otaActiveView === FIRMWARE) fetchCurrentFirmwareVersion(signal);

    return () => {
      controller.abort();
    };
  }, []);

  return {
    isLoading,
    otaActiveView,
    fetchCurrentFirmwareVersion,
  };
};
